(() => {
  const focusServerFeedback = () => {
    const feedback = document.querySelector('[data-gc-contact-feedback]:not([hidden])');
    if (!(feedback instanceof HTMLElement) || document.activeElement === feedback) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    feedback.focus({ preventScroll: true });
    feedback.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'nearest'
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusServerFeedback, { once: true });
  } else {
    focusServerFeedback();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) focusServerFeedback();
  });
})();
